import messageActions from './actions';
// export { default as actions } from './actions';

export default {
  ...messageActions
};
